<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.46286 0.0771484L12.3872 6.00236L17.1771 6.69858L16.9939 7.97208L12.2021 7.27458L11.5335 7.17751L11.2339 6.57129L9.46286 2.98222L7.69179 6.57129L7.39222 7.17751L6.72364 7.27458L2.763 7.84993L5.62886 10.6444L6.11293 11.1156L5.9985 11.7823L5.32222 15.7269L8.17714 14.2258V15.6786L3.61414 18.0771L4.73143 11.565L0 6.95251L6.5385 6.00236L9.46286 0.0771484ZM10.7486 10.3629H18.4629V11.6487H10.7486V10.3629ZM18.4629 12.9344H10.7486V14.2201H18.4629V12.9344ZM15.8914 15.5057H10.7486V16.7914H15.8914V15.5057Z"
      fill="#fff"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
